import { UploadCloud } from 'lucide-react';
import { Button } from "@/components/ui/button";

interface AssetUploadDropzoneProps {
    onFileDrop: (files: FileList | null) => void;
}

export const AssetUploadDropzone = ({ onFileDrop }: AssetUploadDropzoneProps) => {
    return (
        <div className="flex items-center justify-center w-full">
            <label
                htmlFor="dropzone-file"
                onDragOver={e => e.preventDefault()}
                onDrop={e => { e.preventDefault(); onFileDrop(e.dataTransfer.files); }}
                className="flex flex-col items-center justify-center w-full h-64 border-2 border-dashed rounded-lg cursor-pointer bg-muted hover:bg-muted/80"
            >
                <UploadCloud className="w-10 h-10 mb-4 text-muted-foreground" />
                <p className="mb-2 text-sm text-muted-foreground"><span className="font-semibold">Click or drag VRM/FBX/DAE/GLTF/MD/JSON file(s)</span></p>
                <p className="text-xs text-muted-foreground">Maximum size: 25MB</p>
                <input id="dropzone-file" type="file" className="hidden" multiple accept=".vrm,.fbx,.dae,.gltf,.md,.markdown,.json" onChange={e => onFileDrop(e.target.files)} />
            </label>
        </div>
    );
};